
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import AccountHeader from "@/components/account/AccountHeader";
import { Card, CardContent } from "@/components/ui/card";
import ProfileDetails from "@/components/account/ProfileDetails";
import MessageHistory from "@/components/admin/subscribers/MessageHistory";

export default function ProfilePage() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getProfile = async () => {
      setIsLoading(true);
      try {
        const { data: session } = await supabase.auth.getSession();
        
        if (!session.session) {
          navigate('/verify');
          return;
        }
        
        const { data, error } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', session.session.user.id)
          .single();
          
        if (error) throw error;
        setProfile(data);
      } catch (error: any) {
        console.error('Error fetching profile:', error);
        toast({
          title: 'Error loading profile',
          description: error.message,
          variant: 'destructive'
        });
      } finally {
        setIsLoading(false);
      }
    };
    
    getProfile();
  }, [navigate]);

  if (isLoading) {
    return <div className="container py-8">Loading profile...</div>;
  }

  if (!profile) {
    return <div className="container py-8">Profile not found</div>;
  }

  return (
    <div className="container py-4 max-w-4xl mx-auto">
      <AccountHeader phoneNumber={profile.phone_number || ""} />
      
      <div className="space-y-6 mt-8">
        <Card>
          <CardContent className="pt-6">
            <ProfileDetails profile={profile} />
          </CardContent>
        </Card>
        
        <Card>
          <CardContent className="pt-6">
            {profile && <MessageHistory subscriberId={profile.id} showQuoteDetails />}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
